import WithAuthenticationRequired from "./WithAuthenticationRequired";

const ProtectedRoute = ({ component, ...args }) => {
  const Component = WithAuthenticationRequired(component, args);
  return <Component />;
};

export default ProtectedRoute;
